import { useLiveStats } from "./useLiveStats";
import { useBetLegsRealtime } from "./useBetLegsRealtime";
import { useBetsRealtime } from "./useBetsRealtime";

/**
 * Composes the live stats and realtime bet synchronization cluster.
 * Accepts bets state from App.js. Returns liveStats.
 *
 * Pure composition — no internal state, no betsRef, no cloudSynced.
 * Composition order matches original App.js wiring (lines 71, 74, 75).
 */
export function useSlipTrackData({ user, bets, setBets }) {
  const { liveStats } = useLiveStats(bets);
  useBetLegsRealtime({ user, bets, setBets });
  useBetsRealtime({ user, bets, setBets });
  return { liveStats };
}
